// extracted by css-extract-rspack-plugin
export default {"panel":"Panel__panel--ilQOw","head":"Panel__head--k_rHg","body":"Panel__body--tVZVe"};